import { FC } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { padNumber } from "src/utility";
import ModuleTile from "../../ModuleTile/ModuleTile";
import { SectionLayoutProps } from "../Section.types";

const SectionMob: FC<SectionLayoutProps> = ({ title, items, index, subtitle, icon, emblaRef, emblaApi }) => {
  const { t } = useTranslation();
  const handleMovement = (direction: "Next" | "Prev") => () => {
    return direction === "Next" ? emblaApi?.scrollNext() : emblaApi?.scrollPrev();
  };
  return (
    <div className="flex flex-col gap-4 py-5">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <div className="flex shrink-0">{icon}</div>
          <div className="flex flex-col items-start">
            <div className="text-font-subtle text-xs font-medium tracking-wider uppercase">
              {t("Landing.categoryLabel", { number: padNumber(index + 1, 2) })}
            </div>
            <div className="text-xl leading-tight font-semibold">{title}</div>
          </div>
        </div>
        {items.length > 1 && (
          <div className="flex gap-1">
            <button
              onClick={handleMovement("Prev")}
              aria-label={t("Landing.previous")}
              className="text-font-active bg-background-primary-lighter disabled:bg-background-disabled disabled:text-font-disabled rounded-full p-1.5 transition-colors"
            >
              <MdChevronLeft />
            </button>
            <button
              onClick={handleMovement("Next")}
              aria-label={t("Landing.next")}
              className="text-font-active bg-background-primary-lighter disabled:bg-background-disabled disabled:text-font-disabled rounded-full p-1.5 transition-colors"
            >
              <MdChevronRight />
            </button>
          </div>
        )}
      </div>
      <div className="text-font-subtle -mt-1 text-sm leading-snug">{subtitle}</div>
      <div ref={emblaRef} className="flex-1 overflow-hidden">
        <div className="flex items-center gap-3">
          {items.map((item) => (
            <div key={item.key} className={classNames("h-44 shrink-0", items.length > 1 ? "w-4/5" : "w-full")}>
              <ModuleTile item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionMob;
